import ControlGroup from '../../forms/ControlGroup';
import TextInput from '../../forms/controls/TextInput';
import DataAttributes from '../../forms/DataAttributes';
import CurrencyFormatter from '../../tnew/currency/CurrencyFormatter';
import getCurrencyConfiguration from '../../tnew/currency/getCurrencyConfiguration';
import parseMoneyInput from '../../tnew/currency/parseMoneyInput';

class CustomAmountInput {
  controlGroup: ControlGroup;

  control: TextInput;

  minimumAmount: number;

  minimumAmountFormatted: string;

  constructor($controlGroup: HTMLElement) {
    const id = $controlGroup.getAttribute(DataAttributes.ControlGroupFor)!;

    const $amountInput = $controlGroup.querySelector<HTMLInputElement>('.tn-ticket-selector__custom-amount-input')!;

    this.minimumAmount = parseFloat($amountInput.getAttribute('data-tn-minimum-amount') || '0');

    const { app } = window.tnew;

    const currencyFormatter = new CurrencyFormatter(app.bcp47LanguageTag, app.iso4217CurrencyCode);

    this.minimumAmountFormatted = currencyFormatter.format(this.minimumAmount);

    this.control = new TextInput([$amountInput]);

    this.controlGroup = new ControlGroup(id, $controlGroup, this.control);
  }

  getValue() {
    const { app } = window.tnew;

    const currencyConfig = getCurrencyConfiguration(
      app.bcp47LanguageTag,
      app.iso4217CurrencyCode,
    );

    const { amount, isValid, isEmpty } = parseMoneyInput(this.control.value, currencyConfig.thousandsSeparator, currencyConfig.decimalSeparator);

    const isMinimumAmountMet = !isEmpty && amount >= this.minimumAmount;

    return {
      amount,
      isEmpty,
      isMinimumAmountMet,
      isValid,
      rawValue: this.control.value
    };
  }

  showError = (message: string) => {
    this.controlGroup.showError(message);
  };

  clearErrors = () => {
    this.controlGroup.clearErrors();
  };
}

export default CustomAmountInput;
